<template>
    <div class="permisos">
        <vs-row class="mt-4">
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <div class="encabezado">
            <h6 class="mb-0">ALUMNO</h6>
        </div>
        <p class="sinInfo" v-if="!users[0]">Sin información</p>
        <details 
            :key="i"
            v-for="(tr, i) in $vs.getSearch(users, search)"
        >
            <summary><strong class="fontBig">{{tr.nombre}}</strong></summary>
            <vs-row class="mt-3 punteado mb-3 cardColor">
                <vs-col w="12">
                    <h6><i><strong>HERMANOS</strong></i></h6>
                </vs-col>
                <vs-col sm="12" lg="3" v-for="(hermano, j) in tr.hermanos" :key="j" class="p-2 mb-3">
                    <div class="tarjetaHermanos shadow-card">
                        <div class="text-right" @click="activeDesvincular =! activeDesvincular, selectFamiliar = tr, selectHermano = hermano">
                            <i class="fas fa-times-circle">
                                <md-tooltip md-direction="top">Desvincular</md-tooltip>
                            </i>
                        </div>
                        <div class="text-center">
                            <p class="mb-2 fontMedium text-uppercase"><strong>{{hermano.nombre}}</strong></p>
                            <md-chip class="mb-1 fontMedium" :class="'mini-chip ' + parentescoAlumno('hermano')" ><strong class="text-uppercase"> Herman@ </strong></md-chip>
                        </div>
                        <div>
                            <p class="mb-0"><strong>{{hermano.matricula}}</strong></p>
                            <p class="mb-2"><small><i>MATRÍCULA</i></small></p>
                            <p class="mb-0"><strong>{{hermano.institucion}}</strong></p>
                            <p class="mb-2"><small><i>INSTITUCIÓN</i></small></p>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
            <vs-row class="mt-3 cardColor">
                <vs-col w="12">
                    <h6><i><strong>PADRES / TUTOR</strong></i></h6>
                </vs-col>
                <vs-col sm="12" lg="3" v-for="(familiar, j) in tr.familiares" :key="j" class="p-2">
                    <div class="tarjetaHermanos shadow-card">
                        <div class="text-center mb-2">
                            <p class="mb-2 fontMedium text-uppercase"><strong>{{familiar.nombre}}</strong></p>
                            <md-chip class="mb-1 fontMedium" :class="'mini-chip ' + parentescoAlumno(familiar.parentesco)" ><strong class="text-uppercase"> {{ familiar.parentesco }} </strong></md-chip>
                        </div>
                        <p class="mb-0"><i>Alumnos vinculados:</i></p>
                        <div v-for="(hijos, x) in familiar.accesibilidad_hijos" :key="x" :class="familiar.accesibilidad_hijos.length > 1 ? 'divisionLineas' : ''" class="mt-2">
                            <p class="mb-2 text-uppercase"><strong>{{hijos.nombre}}</strong></p>
                            <p class="mb-0"><strong>{{hijos.matricula}}</strong></p>
                            <p class="mb-2"><small><i>MATRÍCULA</i></small></p>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
        </details>
        <desvincular v-model="activeDesvincular" :info="selectFamiliar" :infoHermano="selectHermano"></desvincular>
    </div>
</template>
<script>
import desvincular from './modal/desvicular.vue'
export default {
    props: [
        'users',
        'pages',
        'institucion'
    ],
    data(){
        return{
            search: '',
            activeDesvincular: false,
            selectFamiliar: [],
            selectHermano: []
        }
    },
    components: {
        desvincular
    },
    methods:{ 
        parentescoAlumno(parentesco){
            if(parentesco == 'padre'){
                return 'col-blue'
            }
            if(parentesco == 'madre'){
                return 'col-red'
            }
            if(parentesco == 'hermano'){
                return 'col-green'
            }
        },
    },
    watch:{
    }
}
</script>

<style scoped>
.permisos details, .tableModulo{
    width: 100%;
}
.tableModulo tr th{
    background: #efefef;
    padding: 6px 10px;
}
.tableModulo tr th span{
    font-size: 12px;
}
.tableModulo tr td{
    font-size: 12px;
}
.alinearTexto{
    padding: 6px 10px;
    background: #fdfdfd !important;
}
.alinearTexto p{
    margin:0 !important;
}
.divisionLineasPadres:not(:last-child){
    border-bottom: 2px solid #ececec;
}
</style>
<style lang="scss" scoped>
    .permisos{
        .encabezado{
            border-radius: 14px 14px 0 0;
            background: #F4F7F8;
            padding: 10px 12px;
        }
        .sinInfo{
            padding: 20px;
            text-align: center;
        }
        details{
            padding: 10px 12px;
        }
        details:nth-child(even){
            background-color: #F9FCFD;
        }
        details:not(:last-child){
            border-bottom: 2px solid #ececec;
        }
        details summary{
            font-size: 15px;
        }
    }
    .tarjetaHermanos{
        padding: 4%;
        border-radius: 7px;
        background-color: white;
    }
    .shadow-card {
        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.15) !important;
    }
    @mixin text-colors ($theme, $text-color, $background) {
        &.col-#{$theme}{
            color: $text-color !important;
            background-color: $background !important;
        }
    }

    .md-chip{
        &.mini-chip{
            height: 21px;
            padding: 0px 5px;
            font-size: 12px;
            line-height: 23px;
        }
        @include text-colors ('green', #55ce63, #e8fdeb);
        @include text-colors ('none', #080808, transparent);
        @include text-colors ('red', #f62d51, #f9e7eb); 
        @include text-colors ('blue', #2d8bf6, #c7e1ff ); 
    }

    label {
        margin-bottom: 0.1rem  !important;
    }

    .label-color {   
        @include text-colors ('green', #55ce63, #e8fdeb);
        @include text-colors ('none', #080808, transparent);
        @include text-colors ('red', #f62d51, #f9e7eb);  
        @include text-colors ('blue', #2d8bf6, #c7e1ff ); 
    }

    .fontBiger{
        font-size: 22px;
    }
    .fontBig{
        font-size: 16px;
    }
    .fontMedium{
        font-size: 15px;
    }

    .fontSmall{
        font-size: 12px;
    }

    .breakInfo{
        word-break: break-all;
    }

    .punteado{
         border-bottom: thick double #E5E7E9;
    }

    </style>
<style>
.permisos div.vs-table-content > div.vs-table > table{
        margin: 0 auto !important;
        width: 98% !important;
}
.divisionLineas:not(:last-child){
    border-bottom: 1px solid #E5E7E9; 
}

.divisionLineas{
    padding: 2% 0;
}

.cardColor{
    background-color: #fff;
    padding: 1%;
    border-radius: 10px;
    border-radius: 10px 35px 10px 35px;
}
</style>